module.exports = __webpack_public_path__ + "img/bookcase-bedroom-pc.fbf5bdb6.png";